import { useQuery } from 'react-query';

import { getInvoicesRoute, invoicesKey } from '@features/payments';
import axiosInstance from '@server/axiosInstance';

export const useGetInvoices = () => {
  const { data: invoicesData, isLoading: isLoadingInvoicesData } = useQuery(
    [invoicesKey],
    {
      queryFn: () =>
        axiosInstance.get(getInvoicesRoute).then((res) => res.data),
    },
  );

  return {
    invoicesData,
    isLoadingInvoicesData,
  };
};
